export default __webpack_public_path__ + "static/media/logo.c923e023.svg";